// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteShopCategoryRequestModel from '../../model/delete-shop-category-request-model';
import DeleteShopCategoryRequestDTO from '../dto/delete-shop-category-request-dto';
import dtoSchema from '../schemas/delete-shop-category-request-schema';

export default abstract class DeleteShopCategoryRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteShopCategoryRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteShopCategoryRequestDTO>): DeleteShopCategoryRequestModel;
  static toModel(dto: DeepPartial<DeleteShopCategoryRequestDTO> | undefined | null): DeleteShopCategoryRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteShopCategoryRequestDTO> | undefined | null): DeleteShopCategoryRequestModel | undefined {
    return dto ? new DeleteShopCategoryRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteShopCategoryRequestModel> | DeleteShopCategoryRequestModel): DeleteShopCategoryRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteShopCategoryRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteShopCategoryRequestModel, can not map to DeleteShopCategoryRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
